import React from "react";
import PropTypes from "prop-types";
import { withTranslation, useTranslation } from "react-i18next";
import { Paper, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CobaltIcon } from "da-design-system";

const ConsentTokenErrorBlock = props => {
  const { status } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  const tokenIsNotValid = status === 404;

  return (
    <Paper sx={{ borderRadius: "8px" }}>
      <Box
        pl={9}
        pr={8}
        pt={2}
        pb={2}
        sx={{
          position: "relative",
          borderTopLeftRadius: "8px",
          borderBottomLeftRadius: "8px",
          borderLeft: "8px",
          borderLeftStyle: "solid",
          borderColor: "cobalt.redText"
        }}
      >
        <CobaltIcon
          name="alert-circle"
          sx={{
            color: theme.palette.cobalt.redIcon,
            position: "absolute",
            top: 16,
            left: 26
          }}
        />
        {tokenIsNotValid ? (
          <Box>
            <Typography variant="body2" sx={{ color: "cobalt.lynch" }}>
              {t("consentLogin:token.error.label1")}
            </Typography>
            <Typography variant="body2" sx={{ color: "cobalt.lynch" }}>
              {t("consentLogin:token.error.label2")}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography variant="body2" sx={{ color: "cobalt.lynch" }}>
              {t("consentLogin:token.error.label3")}
            </Typography>
            <Typography variant="body2" sx={{ color: "cobalt.lynch" }}>
              {t("consentLogin:token.error.label4")}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

ConsentTokenErrorBlock.propTypes = {
  status: PropTypes.number
};

ConsentTokenErrorBlock.defaultProps = {
  status: 404
};

export default withTranslation()(ConsentTokenErrorBlock);
